export default "assets/images/logo_bg-0f3fd239.png";